// @flow
import {observer} from 'mobx-react';
import React, { Component } from 'react';
import {RadioGroup, Radio} from 'react-radio-group';
import { assetUrl } from '~/src/config/routes.js';
import classNames from 'classnames';
import SVG from 'react-inlinesvg';
import './RadioButtons.scss';

type Props = {
  value: string | number,
  setValue: Function,
  propertyName: string,
  items: Array<Object>,
  disabled?: boolean,
  isMobile?: boolean
}

@observer
class RadioButtons extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleChange = (value: string) => {
    this.props.setValue(this.props.propertyName, value);
  }

  safeClass = (value: string) => {
    if (value) {
      value = value.replace(/\:/g, ''); // eslint-disable-line
      if (/^\d/.test(value)) {
        value = 'n' + value;
      }
    }
    return value;
  }

  render() {
    return (
      <RadioGroup
        className={classNames(
          'radio',
          {'disabled': this.props.disabled,},
          {'is-mobile': this.props.isMobile,}
        )}
        name="radio"
        selectedValue={this.props.value}
        onChange={this.handleChange}
      >
        {this.props.items.map(item => (
          <label
            key={item.key || item.value}
            className={classNames(
              item.value.mode,
              this.safeClass(item.icon),
              {
                'with-image': item.img,
                'with-label': item.label,
                'active': this.props.value === (item.key || item.value)
              }
            )}
          >
            <SVG src={assetUrl(item.icon)} />
            <Radio id={item.value} value={item.value} />
            {item.img}
            <h4>{item.label || item.value}</h4>
            {item.subLabel && <h5>{item.subLabel}</h5>}
          </label>
        ))}
      </RadioGroup>
    );
  }
}

export default RadioButtons;
